<template>
  <SoDialog v-model="value" card-title="Submit Meter Reading" :max-width="1200">
    <SubmitReadings :used-in-modal="value" />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SubmitReadings from "../components/SubmitReadings/SubmitReadings.vue"
  import SoDialog from "@/components/SoDialog.vue"

  export default defineComponent({
    components: { SoDialog, SubmitReadings },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
